var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTakePhotoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 16.25,
    r: 3.75,
    stroke: "#1C274C",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2222 26.25H17.7778C21.6791 26.25 23.6297 26.25 25.0309 25.3307C25.6376 24.9328 26.1584 24.4214 26.5637 23.8258C27.5 22.4501 27.5 20.5349 27.5 16.7045C27.5 12.8742 27.5 10.959 26.5637 9.58325C26.1584 8.98767 25.6376 8.4763 25.0309 8.07835C24.1306 7.48767 23.0033 7.27654 21.2775 7.20107C20.4539 7.20107 19.7448 6.58835 19.5833 5.79545C19.3411 4.60611 18.2774 3.75 17.0421 3.75H12.9579C11.7226 3.75 10.6589 4.60611 10.4167 5.79545C10.2552 6.58835 9.54607 7.20107 8.72249 7.20107C6.99667 7.27654 5.86944 7.48767 4.96905 8.07835C4.36244 8.4763 3.84161 8.98767 3.43628 9.58325C2.5 10.959 2.5 12.8742 2.5 16.7045C2.5 20.5349 2.5 22.4501 3.43628 23.8258C3.84161 24.4214 4.36244 24.9328 4.96905 25.3307C6.3703 26.25 8.32094 26.25 12.2222 26.25Z",
    stroke: "#1C274C",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 12.5H22.5",
    stroke: "#1C274C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakePhotoIcon);
export default __webpack_public_path__ + "static/media/take-photo-icon.f3bb667449748c567efe0bafa88aab19.svg";
export { ForwardRef as ReactComponent };